/**
 * Verzio <-> URL-alak forditas EGY helyen.
 *
 * Miert kell: a `.` es a `-` kozti forditas korabban HAROM helyen elt kulon
 * (`ReleaseHubPage` inline `replace`, `ChangelogTab`, `VersionTestGroup`), es a
 * ket irany elcsuszott — az URL kotojeles alakot kapott, a visszaolvasas viszont
 * a nyers parametert hasznalta ref-kulcskent, ahol a kulcs a PONTOS verzio.
 * Ezert a megosztott/ujratoltott melylink nem nyitott ki es nem gorgetett.
 */

/** `4.2.0` -> `4-2-0` (DOM-`id`-hez es URL-parameterhez). */
export function versionToHash(version: string): string {
  return version.replace(/\./g, '-');
}

/**
 * URL-parameter -> valodi verzio.
 *
 * Elfogadja a kotojeles (`4-2-0`) es a pontos (`4.2.0`) alakot is — az elso a
 * felulet altal generalt link, a masodik a kezzel irt. Ismeretlen verziora
 * `null`-t ad: NEM talalgat, es nem ad vissza olyan kulcsot, amire semmi nem
 * illeszkedik.
 */
export function resolveVersionParam(
  param: string | null | undefined,
  knownVersions: readonly string[]
): string | null {
  if (!param) return null;
  return knownVersions.find(v => v === param || versionToHash(v) === param) ?? null;
}
